const applicationJs = require.context('application/javascripts/', true, /\.js$/)
applicationJs.keys().forEach(applicationJs)